import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./mainTextList.css";

const MainTextList = () => {
  const [selectedText, setSelectedText] = useState("PHOTOGRAPHERS");
  const navigate = useNavigate();

  const handleMouseEnter = (text) => setSelectedText(text);
  const handleMouseLeave = () => setSelectedText("PHOTOGRAPHERS");

  const handleClick = (text) => {
    if (text === "PHOTOGRAPHERS") {
      navigate("/photographers");
    } else if (text === "DIRECTORS") {
      navigate("/directors");
    } else if (text === "ABOUT") {
      navigate("/about");
    } else if (text === "CONTACT") {
      navigate("/contact");
    }
  };

  return (
    <div className="main-text-list" onMouseLeave={handleMouseLeave}>
      <div
        className={`main-text ${
          selectedText === "PHOTOGRAPHERS" ? "filled" : "outlined"
        }`}
        onMouseEnter={() => handleMouseEnter("PHOTOGRAPHERS")}
        onClick={() => handleClick("PHOTOGRAPHERS")}
      >
        PHOTOGRAPHERS
      </div>
      <div
        className={`main-text ${
          selectedText === "DIRECTORS" ? "filled" : "outlined"
        }`}
        onMouseEnter={() => handleMouseEnter("DIRECTORS")}
        onClick={() => handleClick("DIRECTORS")}
      >
        DIRECTORS
      </div>
      <div
        className={`main-text ${
          selectedText === "ABOUT" ? "filled" : "outlined"
        }`}
        onMouseEnter={() => handleMouseEnter("ABOUT")}
        onClick={() => handleClick("ABOUT")}
      >
        ABOUT
      </div>
      <div
        className={`main-text ${
          selectedText === "CONTACT" ? "filled" : "outlined"
        }`}
        onMouseEnter={() => handleMouseEnter("CONTACT")}
        onClick={() => handleClick("CONTACT")}
      >
        CONTACT
      </div>
    </div>
  );
};

export default MainTextList;
